module.exports = __webpack_public_path__ + "img/gzhxq.0293eb16.jpg";